import { colors } from '../theme';

function Hero() {
  return (
    <section id="home" className="min-h-screen flex flex-col justify-center items-center px-6 md:px-12 pt-32 pb-16 max-w-container mx-auto relative overflow-hidden">

      <div className="space-y-8 text-center z-10 relative">
        <div className="space-y-3">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-normal text-primary leading-tight animate-fade-in-up animation-delay-100">
            Hi! I'm
          </h1>
          <h2 className="text-6xl md:text-7xl lg:text-8xl font-normal text-primary leading-tight animate-fade-in-up animation-delay-200">
            Stephanie
          </h2>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-primary font-normal max-w-3xl mx-auto">
          <div className="inline-block animate-fade-in-up animation-delay-300">
            <p className="text-xl md:text-2xl leading-relaxed bg-bg-light rounded-[100px] px-6 md:px-8 py-3 border border-border">
              Designer & Developer
            </p>
          </div>
          <p className="text-base md:text-lg text-primary leading-relaxed animate-fade-in-up animation-delay-400">
            Turning complexity into intuitive experiences
          </p>
          <div className="flex items-center justify-center gap-2 animate-fade-in-up animation-delay-550">
            <span className="material-symbols-outlined text-base" style={{ color: colors.accentGreen, fontVariationSettings: '"FILL" 1' }}>near_me</span>
            <span className="text-sm text-text-muted font-normal">Based in <span className="font-semibold text-text-medium">Vancouver</span>, available worldwide</span>
          </div>
        </div>

        <div className="pt-4">
          <a
            href="#work"
            className="inline-flex items-center gap-6 bg-[#1A1A1A] text-white font-normal hover:bg-[#CBFB8F] hover:text-[#1A1A1A] transition-all text-base md:text-lg pl-6 pr-1.5 py-1.5 rounded-full animate-fade-in-up animation-delay-600 group"
          >
            View Work
            <span className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-white group-hover:bg-[#1A1A1A] rounded-full transition-colors duration-300">
              <span className="material-symbols-outlined text-[#1A1A1A] group-hover:text-white text-lg md:text-xl group-hover:rotate-90 transition-transform duration-300">
                east
              </span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;

